/*
 * CUSTOM (Schuhbeck): PDP redesign behaviors.
 * - Mobile sticky buy bar: appears once the buy box scrolls out of view.
 *   Its button proxies the real add-to-cart button, so every cart behavior
 *   (ajax add, loader, drawer, quantity) stays in the vendor code path.
 * - Availability line + sticky price: kept in sync with variant changes via
 *   the vendor's VARIANT_CHANGE event on <product-variants>
 *   (see component-product-form.js — the event does not bubble, so we listen
 *   on the element itself). Products without a variant picker never fire it;
 *   for those the server-rendered state is already correct.
 */
(function () {
  'use strict';

  function initProductPage(page) {
    if (page.dataset.pdpCustomInit) return;
    page.dataset.pdpCustomInit = 'true';

    var stickyBar = page.querySelector('[data-js-pdp-sticky-bar]');
    var buyBox = page.querySelector('.product-actions');
    var realAtc = page.querySelector('[data-js-product-add-to-cart]');
    var realAtcText = page.querySelector('[data-js-product-add-to-cart-text]');
    var availability = page.querySelector('[data-js-pdp-availability]');
    var variants = page.querySelector('product-variants');

    // sticky bar

    if (stickyBar && buyBox && realAtc) {
      var stickyAtc = stickyBar.querySelector('[data-js-pdp-sticky-atc]');
      var stickyAtcText = stickyBar.querySelector('[data-js-pdp-sticky-atc-text]');

      stickyAtc.addEventListener('click', function () {
        realAtc.click();
      });

      var syncAtcState = function () {
        stickyAtc.classList.toggle('disabled', realAtc.classList.contains('disabled'));
        if (stickyAtcText && realAtcText) {
          stickyAtcText.textContent = realAtcText.textContent;
        }
      };
      syncAtcState();
      new MutationObserver(syncAtcState).observe(realAtc, { attributes: true, attributeFilter: ['class'] });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var entry = entries[0];
          var passed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          stickyBar.classList.toggle('is-visible', passed);
          stickyBar.setAttribute('aria-hidden', passed ? 'false' : 'true');
        }).observe(buyBox);
      }
    } else if (stickyBar) {
      // no buy box / add-to-cart on this template — the bar has nothing to do
      stickyBar.remove();
    }

    // variant changes → availability line + sticky price

    if (variants) {
      variants.addEventListener('VARIANT_CHANGE', function () {
        var variant = variants.currentVariant;

        if (availability) {
          availability.classList.toggle('pdp-availability--soldout', !(variant && variant.available));
        }

        var stickyPrice = page.querySelector('[data-js-pdp-sticky-price]');
        if (
          stickyPrice && variant &&
          typeof variants._formatMoney === 'function' &&
          window.KROWN && KROWN.settings && KROWN.settings.shop_money_format
        ) {
          stickyPrice.innerHTML = variants._formatMoney(variant.price, KROWN.settings.shop_money_format);
        }
      });
    }
  }

  function initAll() {
    document.querySelectorAll('product-page.main-product').forEach(initProductPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var page = e.target.querySelector('product-page.main-product');
    if (page) initProductPage(page);
  });
})();
